const CLIENT_ID = spat.config.googleCalendar.clientId;
const API_KEY = spat.config.googleCalendar.apiKey;

const DISCOVERY_DOC = 'https://www.googleapis.com/discovery/v1/apis/calendar/v3/rest';

const SCOPES = 'https://www.googleapis.com/auth/calendar.readonly';

let tokenClient = null; // トークンクライアントの初期化
let isInitialized = false; // 初期化フラグ

var gCalendar = {
  gapiLoad: () => {
    // Google APIクライアントライブラリを読み込み、初期化を完了するまで待機
    return new Promise((resolve) => {
      gapi.load('client', async () => {
        await gCalendar.initializeGapiClient();
        resolve();
      });
    });
  },

  initializeGapiClient: async () => {
    // Google APIクライアントライブラリを初期化
    await gapi.client.init({
      apiKey: API_KEY,
      discoveryDocs: [DISCOVERY_DOC],
    });
  },

  gsiLoad: () => {
    // Google Identity Servicesのトークンクライアントを初期化
    tokenClient = google.accounts.oauth2.initTokenClient({
      client_id: CLIENT_ID,
      scope: SCOPES,
      prompt: '',
      callback: async (resp) => { // callback関数をここで定義
        if (resp.error !== undefined) {
          console.error('Token client callback error:', resp);
          return;
        }
      }
    });
  },

  initialize: async () => {
    if (!isInitialized) {
      await gCalendar.gapiLoad();
      await gCalendar.gsiLoad();
      isInitialized = true;
    }
  },

  /**
   *グーグルカレンダーからイベントを取得する処理
   */
  listUpcomingEvents: async () => {
    await gCalendar.initialize();


    if (!tokenClient) {
      console.error('tokenClient is not initialized');
      return;
    }

    // トークンが存在しないか、トークンが無効な場合のみ認証を実行
    if (!gapi.client.getToken()) {
      try{
        // トークンを取得して、コールバック関数が終了するまで待機する
        await new Promise((resolve, reject) => {
          tokenClient.callback = async (resp) => {
            if (resp.error !== undefined) {
              console.error('Token client callback error:', resp);
              reject(new Error('トークンの取得に失敗しました'));
              return;
            }
            resolve();
          };
          tokenClient.requestAccessToken({ prompt: '' });
        });
      }
      catch (err) {
        console.error('Failed to handle token client callback:', err);
        alert('処理に失敗しました。再試行してください。');
      }
    }

    // トークンが存在する場合、認証をスキップしてイベントをリスト
    let response;

    try {
      const now = new Date();
      const todayStart = new Date(now.getFullYear(), now.getMonth(), now.getDate(), 0, 0, 0);
      const todayEnd = new Date(now.getFullYear(), now.getMonth(), now.getDate(), 23, 59, 59);
      const request = {
        'calendarId': 'primary',
        'timeMin': todayStart.toISOString(),
        'timeMax': todayEnd.toISOString(),
        'showDeleted': false,
        'singleEvents': true,
        'orderBy': 'startTime',
      };
      response = await gapi.client.calendar.events.list(request);
    } catch (err) {
      // トークン期限切れの場合、再認証
      if (err.result?.error?.code === 401) {
        gapi.client.setToken('');
        return await gCalendar.listUpcomingEvents();
      } else {
        console.error('予定を取得できませんでした', err);
        alert('リロードして再度お試しください');
        return;
      }
    }

    return { schedules: response.result.items };
  }
};

export default gCalendar;

